import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PogodaNewsService, SharedService } from './../../../services';
import { DomSanitizer } from '@angular/platform-browser';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'widget-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  constructor(
    private _news: PogodaNewsService,
    private _shared: SharedService,
    private _sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) { }

  isSmallIcons;
  loading = false;
  selectedCity;
  timeUTC;
  dataOther = [];
  categories = {
    '': 'Без категории',
    'news': 'Новость',
    'meteo': 'Метео',
    'gidro': 'Гидро',
    'agro': 'Агро',
    'climate': 'Климат',
    'press': 'Пресс-релиз',
    'storm': 'Шторм',
    'gdr_storm': 'Гидро шторм'
    // { id:'storm1', name: 'Шторм1' }
  };

  getTrueText(html) {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  getTimezone() {
    return this.timeUTC ? '+0' : (this.selectedCity.timezone < 0 ? '' + this.selectedCity.timezone : '+' + this.selectedCity.timezone)
  }

  getNews() {
    this.loading = true;
    this._news.lastDays().subscribe(
      async res => {
        this.dataOther = res;
        // this.dataFirst6 = this.dataOther.splice(0, 6);
        // console.log(res);
      },
      err => {
        console.error(err)
      }
    );
  }

  ngAfterViewChecked() {
    this._shared.currentFooterHeight.subscribe(state => {
      this.isSmallIcons = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');    
    });
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.getNews();
    this._shared.currentCity.subscribe(city => {
      this.selectedCity = city;
    });
    this._shared.currentTime.subscribe(time => {
      this.timeUTC = time;
    });
  }

}
